import FuelCalcBase from './FuelCalcBase';
import Ratio from './Ratio';
import { MathFormula } from './Math';
import { PropertyType,RatioType } from './Settings';
import {
    VerifyNumericLimit_Btw_MinMax,
    VerifyNumericLimit_ByLimit,
    RoundValueASTM,
    RoundValueASTM_ValAsStr,
    Approximates,
    RemoveScientificNotation,
    GetDecimalsFromString,
    VpsCommodity,
    VpsGravityType,
    VpsTemperatureUnit,
    VpsQuantityUnit
} from './FuelMath';


export default class Blending extends FuelCalcBase {

    //Input Fields
    #m_Density1 = "";
    #m_Density2 = "";
    #m_Property1 = "";
    #m_Property2 = "";
    #m_PropertyType;
    #m_ComponentRatio;
    #m_ComponentRatioType;
    #m_PropertyTarget = "";

    //Output Fields
    #m_BlendRatio;
    #m_BlendRatioType;
    #m_BlendProperty = "";
    #m_Information = "";

    //Module Fields
    #m_HasDensity;

    // // <summary>Creates a new instance of the blending class.</summary>
	// Public Sub New()
	// End Sub

	// // <summary>Creates a new instance of the blending class with the five required properties to 
	// // calculate a blend parameter value.</summary>
	// Public Sub New(ByVal comp1Property As Double, ByVal comp2Property As Double, _
	// ByVal propertyType As PropertyType, ByVal componentRatio As Ratio, ByVal ratioType As RatioType)

	// 	MyBase.New()
	// 	this.Component1_Property = comp1Property.toString()
	// 	this.Component2_Property = comp2Property.toString()
	// 	this.ComponentPropertyType = propertyType
	// 	if propertyType = Blending.PropertyType.Density Then
	// 		this.Component1_Density = comp1Property.toString()
	// 		this.Component2_Density = comp2Property.toString()
	// 	End if
	// 	this.ComponentRatio = componentRatio
	// 	this.ComponentRatioType = ratioType

	// End Sub

	// // <summary>Creates a new instance of the blending class with the four required properties to 
	// // calculate a blend ratio.</summary>
	// Public Sub New(ByVal comp1Property As Double, ByVal comp2Property As Double, _
	// ByVal propertyType As PropertyType, ByVal blendPropertyTarget As Double)

	// 	MyBase.New()
	// 	this.Component1_Property = comp1Property.toString()
	// 	this.Component2_Property = comp2Property.toString()
	// 	this.ComponentPropertyType = propertyType
	// 	if propertyType = Blending.PropertyType.Density Then
	// 		this.Component1_Density = comp1Property.toString()
	// 		this.Component2_Density = comp2Property.toString()
	// 	End if
	// 	this.BlendPropertyTarget = blendPropertyTarget.toString()
	// End Sub


    // <summary>Specifies the density of component 1</summary>
    // <value>Value between 611.5 and 1163 kg/m3.</value>
    get Component1_Density() {
        return this.#m_Density1;
    }

    set Component1_Density(value) {
        let propertyName = "Component1 Density Property";
        if (!this.CheckDecimalCharacter(value, propertyName)) {
            this.#m_HasDensity = false;
            return;
        }
        else if (!VerifyNumericLimit_Btw_MinMax(value, 611.5, 1163.0)) {
            this.RaiseError(1020, propertyName);
            this.#m_HasDensity = false;
            return;
        }

        this.#m_Density1 = value;
        if (this.#m_Density2.length > 0)
            this.#m_HasDensity = true;
    }

    // <summary>Specifies the density of component 2</summary>
    // <value>Value between 611.5 and 1163 kg/m3.</value>
    get Component2_Density() {

        return this.#m_Density2;
    }
    set Component2_Density(value) {
        let propertyName = "Component2 Density Property";
        if (!this.CheckDecimalCharacter(value, propertyName)) {
            this.#m_HasDensity = false;
            return;
        }
        else if (!VerifyNumericLimit_Btw_MinMax(value, 611.5, 1163.0)) {
            this.RaiseError(1020, propertyName)
            this.#m_HasDensity = false;
            return;
        }

        this.#m_Density2 = value;
        if (this.#m_Density1.length > 0)
            this.#m_HasDensity = true;
    }

    // <summary>Specifies the property value of component 1</summary>
    // <value>Value must be greater than zero</value>
    get Component1_Property() {
        return this.#m_Property1;
    }
    set Component1_Property(value) {
        let propertyName = "Component1 Property";
        if (!this.CheckDecimalCharacter(value, propertyName))
            return;
        else if (!this.VerifyValue(value)) {
            this.RaiseError(1150, propertyName);
            return;
        }

        this.#m_Property1 = value;
    }

    // <summary>Specifies the property value of component 1</summary>
    // <value>Value must be greater than zero</value>
    get Component2_Property() {
		
        return this.#m_Property2;
    }

    set Component2_Property(value) {
		
        let propertyName = "Component2 Property";
        if (!this.CheckDecimalCharacter(value, propertyName)) {
            return;
        }
        else if (!this.VerifyValue(value)) {
            this.RaiseError(1150, propertyName);
            return;
        }

        this.#m_Property2 = value;
    }

    // <summary>Specifies the type of property</summary>
    // <value>Accepatble values are: Density, Flash point, Viscosity or Proportional</value>
    get ComponentPropertyType() {

        return this.#m_PropertyType;
    }
    set ComponentPropertyType(value) {
        if (value < PropertyType.Density || value > PropertyType.Proportional) {
            this.RaiseError(1000, "Property Type");
            return;
        }

        this.#m_PropertyType = value;
    }

    // <summary>Specifies the ratio of both components</summary>
    // <value>Must be a valid, percentage based ratio. (Total of the ratio factors must be 1 or 100)</value>
    get ComponentRatio() {

        return this.#m_ComponentRatio;
    }
    set ComponentRatio(value) {
        this.#m_ComponentRatio = value;
    }

    // <summary>Specifies the type of ratio of both components</summary>
    // <value>Must be either volume or weight</value>
    get ComponentRatioType() {

        return this.#m_ComponentRatioType;
    }
    set ComponentRatioType(value) {
        if (value < RatioType.weight || value > RatioType.volume) {
            this.RaiseError(1000, "Ratio Type");
            return;
        }

        this.#m_ComponentRatioType = value;
    }

    // <summary>Specifies the blend target value of the property.</summary>
    // <value>Must be greater than zero</value>
    get BlendPropertyTarget() {

        return this.#m_PropertyTarget;
    }
    set BlendPropertyTarget(value) {
        let propertyName = "Blend Property Target";
        if (!this.CheckDecimalCharacter(value, propertyName)) {
            return;
        }
        else if (!this.VerifyValue(value)) {
            this.RaiseError(1150, propertyName);
            return;
        }

        this.#m_PropertyTarget = value;
    }

    // <summary>Returns the calculated blend ratio.</summary>
    // <returns>A ratio</returns>
    get BlendRatio() {

        return this.#m_BlendRatio;
    }


    // <summary>Returns the type of blend ratio.</summary>
    // <returns>A ratio type, either Volume or Weight</returns>
    get BlendRatioType() {
        return this.#m_BlendRatioType;
    }

    // <summary>Returns the calculated blend property value.</summary>
    // <returns>A string value</returns>
    get BlendProperty() {

        return this.#m_BlendProperty;
    }

    // <summary>Returns additional information if applicable.</summary>
    // <returns>A string value</returns>
    get Information() {

        return this.#m_Information;
    }


	//#region 
	// <summary>Calculates the blend ratio based on given component properties and a blend target</summary>
	// <param name="blendRatioType">The type of blend ratio (Volume or Weight)</param>
	// <returns>true if succesfull otherwise false</returns>
	// <remarks></remarks>
    GetBlendRatio(blendRatioType) {
        let calcRatio = null;
        let calcRatioType;
        let methodName = "GetBlendRatio";
		
        try {

            this.#m_BlendRatio = null;
            this.#m_BlendRatioType = null;

            if (this.Exception || (!this.MinimumDetails(methodName, 1))) {
                return false;
            }
			
            switch (this.#m_PropertyType) {
                case PropertyType.FlashPoint: {
                    calcRatio = this.GetFlashPointRatio(parseFloat(this.#m_Property1), parseFloat(this.#m_Property2), parseFloat(this.#m_PropertyTarget));
                    calcRatioType = RatioType.volume;
                }
                    break;
                case PropertyType.Viscosity: {
                    calcRatio = this.GetViscosityRatio(parseFloat(this.#m_Property1), parseFloat(this.#m_Property2), parseFloat(this.#m_PropertyTarget));
                    calcRatioType = RatioType.weight;
                }
                    break;
                case PropertyType.Density: {
                    calcRatio = this.GetProportionalRatio(parseFloat(this.#m_Property1), parseFloat(this.#m_Property2), parseFloat(this.#m_PropertyTarget));
                    calcRatioType = RatioType.volume;
                }
                    break;
                case PropertyType.Proportional: {
                    calcRatio = this.GetProportionalRatio(parseFloat(this.#m_Property1), parseFloat(this.#m_Property2), parseFloat(this.#m_PropertyTarget));
                    calcRatioType = RatioType.weight;
                }
                    break;
            }

            if (!calcRatioType == blendRatioType) {
                if (!this.#m_HasDensity) {
                    if (blendRatioType == RatioType.volume) {
                        this.#m_Information = "Cannot determine requested volume ratio without density values.";
                    }
                    else {
                        this.#m_Information = "Cannot determine requested weight ratio without density values.";
                    }
                    return false
                }
                else {
                    if (blendRatioType == RatioType.volume) {
                        this.#m_BlendRatio = this.GetVolumeRatio(calcRatio, parseFloat(this.#m_Density1), parseFloat(this.#m_Density2));
                    }
                    else {
                        this.#m_BlendRatio = (this.GetWeightRatio(calcRatio, parseFloat(this.#m_Density1), parseFloat(this.#m_Density2)));
                    }
                }
            }
            else {
                this.#m_BlendRatio = calcRatio;
            }


            this.#m_BlendRatioType = blendRatioType;
            return true;
        }
        catch (ex) {
            this.RaiseError(methodName, ex.Message);
            return false;
        }
    }



	// <summary>Calculates the resulting blend value based on a given blend ratio and known component properties</summary>
	// <returns>true if succesfull otherwise false</returns>
    // <remarks>Density and Flashpoint require Volume ratio, other properties require Weight ratio</remarks>
	GetBlendPropertyValue() {

		let ratioToUse;
		let methodName = "GetBlendPropertyValue";

		try {

			this.#m_BlendProperty = "";
			this.#m_Information = "";

			if (this.Exception || !this.MinimumDetails(methodName, 2)) {
				return false;
			}

			if (this.#m_ComponentRatioType == RatioType.weight) {
				if (!this.#m_HasDensity && (this.#m_PropertyType == PropertyType.FlashPoint)) {
					this.#m_Information = "Flash point blend property can be only be determined with a volume ratio.";
					this.#m_BlendProperty = "N.A.";
					return false;
				}
				else if (this.ComponentPropertyType == PropertyType.FlashPoint || this.ComponentPropertyType == PropertyType.Density) {
					// Use Volume Ratio
					ratioToUse = this.GetVolumeRatio(this.#m_ComponentRatio, parseFloat(this.#m_Density1), parseFloat(this.#m_Density2));
				}
				else {
					//Use Weight Ratio
					ratioToUse = this.#m_ComponentRatio;
				}

			} else {

				// (this.m_ComponentRatioType == RatioType.volume)
				if (this.ComponentPropertyType == PropertyType.FlashPoint || this.ComponentPropertyType == PropertyType.Density) {
					//Use Volume Ratio
					ratioToUse = this.#m_ComponentRatio;
				}
				else if (!this.#m_HasDensity) {
					this.#m_Information = "Cannot determine blend property without density values.";
					this.#m_BlendProperty = "N.A.";
					return false;
				}
				else {
					//Use Weight Ratio
					ratioToUse = this.GetWeightRatio(this.#m_ComponentRatio, parseFloat(this.#m_Density1), parseFloat(this.#m_Density2));
				}
			}

			//Viscosity and other properties are in weight percent
			if (this.#m_PropertyType == PropertyType.FlashPoint) {
				this.#m_BlendProperty = this.GetBlendFlashPoint(parseFloat(this.#m_Property1), parseFloat(this.#m_Property2), ratioToUse).toString()
			}
			else if (this.#m_PropertyType == PropertyType.Viscosity) {
				this.#m_BlendProperty = this.GetBlendViscsity(parseFloat(this.#m_Property1), parseFloat(this.#m_Property2), ratioToUse).toString();
			}
			else {
				this.#m_BlendProperty = this.GetBlendProperty(parseFloat(this.#m_Property1), parseFloat(this.#m_Property2), ratioToUse).toString();
			}

			return true;
		}
		catch (ex) {
			this.RaiseError(methodName, ex.Message)
			return false
		}

	}
	

	// <summary>Converts Volume ratio to Weight ratio </summary>
	// <param name="volumeRatio">Volume ratio of blend</param>
	// <param name="comp1Density">Density of 1st blend component</param>
	// <param name="comp2Density">Density of 2nd blend component</param>
	// <returns>A ratio object containing the weight ratio</returns>
	// <remarks></remarks>
	GetWeightRatio(volumeRatio, comp1Density, comp2Density) {
		
		let newRatio = new Ratio();
		newRatio.B = MathFormula.roundAccurately((volumeRatio.B * comp2Density) / (volumeRatio.B * comp2Density + (volumeRatio.A * comp1Density)), 4);
		newRatio.A = 1 - newRatio.B;
		return newRatio;
	}
	

	// <summary>Converts Weight ratio to Volume ratio </summary>
	// <param name="weightRatio">Weight ratio of blend</param>
	// <param name="comp1Density">Density of 1st blend component</param>
	// <param name="comp2Density">Density of 2nd blend component</param>
	// <returns>A ratio object containing the volume ratio</returns>
	// <remarks></remarks>
	GetVolumeRatio(weightRatio, comp1Density, comp2Density) {
		let newRatio = new Ratio();;
		newRatio.B = MathFormula.roundAccurately(((weightRatio.B / comp2Density) / (weightRatio.B / comp2Density + (weightRatio.A / comp1Density))), 4);
		newRatio.A = 1 - newRatio.B;
		return newRatio;
	}

	//#endregion

	//#region 

	// <summary>Verifies that minimum required property values have been supplied.</summary>
	// <param name="methodName">Method name that will be shown in the exception description.</param>
	// <param name="calculationType">The type of calculation for which to check the minimum details.</param>
	// <returns>true if all required properties have valid values; otherwise false.</returns>
	MinimumDetails(methodName, calculationType) {
		
		if (calculationType == 1) {
			if (!(this.#m_Property1.length == 0 || this.#m_Property2.length == 0 || this.#m_PropertyTarget.length == 0))
			return true;
		}
		else {
			if (!(this.#m_Property1.length == 0 || this.#m_Property2.length == 0 || this.#m_ComponentRatio == null)) {
				return true;
			}
		}
		this.RaiseError(1004, methodName);
		return false;
	}
	

	// <summary>Calculates the flash point of the fimal blend based on a given ratio</summary>
	// <param name="comp1FlashPoint">Flash point of 1st blend component</param>
	// <param name="comp2FlashPoint">Flash point of 2nd blend component</param>
	// <param name="blendRatio">Volume ratio of the blend</param>
	// <returns>A double value containing the flash point of the blend</returns>
	// <remarks></remarks>
	GetBlendFlashPoint(comp1FlashPoint, comp2FlashPoint, blendRatio) {
		
		let fuel1FPIndex = 10 ** (-6.1188 + (2414.0 / (comp1FlashPoint + 230.6)));
		let fuel2FPIndex = 10 ** (-6.1188 + (2414.0 / (comp2FlashPoint + 230.6)));

		//- dblFPIndex_Target=(dblFPIndex_Fuel2*dblPercent)+(dblFPIndex_Fuel1*(1-dblPercent))
		let targetFPIndex = fuel1FPIndex - (blendRatio.B * (fuel1FPIndex - fuel2FPIndex));

		let fp = (2414.0 / (6.1188 + Math.log10(targetFPIndex))) - 230.6;
		return fp;
	}


	// <summary>Calculates the value of a blend property based on a given ratio</summary>
	// <param name="comp1Property">Property value of 1st blend component</param>
	// <param name="comp2Property">Property value of 2nd blend component</param>
	// <param name="blendRatio">Weight ratio of the blend</param>
	// <returns>A double value containing the property value in the blend</returns>
	// <remarks></remarks>
	GetBlendProperty(comp1Property, comp2Property, blendRatio) {
		
		let value = Math.abs(comp1Property + (blendRatio.B * (comp2Property - comp1Property)));
		return value;
	}


	// <summary>Calculates the final blend viscosity based on a given ratio</summary>
	// <param name="comp1Viscosity">Viscosity of 1st blend component</param>
	// <param name="comp2Viscosity">Viscosity of 2nd blend component</param>
	// <param name="blendRatio">Weight ratio of the blend</param>
	// <returns>A double value containing the viscosity of the blend</returns>
	// <remarks></remarks>
	GetBlendViscsity(comp1Viscosity, comp2Viscosity, blendRatio) {
		
		//- Exxon Algorithms ex Rudy
		//- fuel1ViscMod = (Math.log10(Math.log10(fuel1Viscosity + .6))) / .394 + 3.2927
		//- fuel2ViscMod = (Math.log10(Math.log10(fuel2Viscosity + .6))) / .394 + 3.2927
		//- blendViscMod = fuel1ViscMod + (percent / 100) * (fuel2ViscMod - fuel1ViscMod)
		//- n = (blendViscMod - 3.2927) * .394
		//- BlendVisc = (10 ^ (10 ^ n)) - .6

		//- BP Algorithms ex IP M.Wood
		let fuel1ViscMod = (Math.log10(Math.log10(comp1Viscosity + 0.8))) * 33.468 + 23.097;
		let fuel2ViscMod = (Math.log10(Math.log10(comp2Viscosity + 0.8))) * 33.468 + 23.097;
		let blendViscMod = fuel1ViscMod + (blendRatio.B * (fuel2ViscMod - fuel1ViscMod));
		let n = (blendViscMod - 23.097) / 33.468;
		//let tpmn=Math.pow(10,n)
		
		return (Math.pow(10, Math.pow(10,n))) - 0.8;
	}


	// <summary>Calculates the blend ratio based on a given target viscosity</summary>
	// <param name="comp1Viscosity">Viscosity of 1st blend component</param>
	// <param name="comp2Viscosity">Viscosity of 2nd blend component</param>
	// <param name="targetViscosity">Target viscosity of final blend</param>
	// <returns>A ratio object containing the calculated ratio</returns>
	// <remarks></remarks>
	GetViscosityRatio(comp1Viscosity, comp2Viscosity, targetViscosity) {
		
		//- Exxon ex Rudy
		//- fuel1ViscMod = (Math.log10(Math.log10(fuel1Viscosity + .6))) / .394 + 3.2927
		//- fuel2ViscMod = (Math.log10(Math.log10(fuel2Viscosity + .6))) / .394 + 3.2927
		//- targetViscMod = (Math.log10(Math.log10(targetViscosity + .6))) / .394 + 3.2927

		//- BP ex IP M. Wood
		let fuel1ViscMod = (Math.log10(Math.log10(comp1Viscosity + 0.8))) * 33.468 + 23.097;
		let fuel2ViscMod = (Math.log10(Math.log10(comp2Viscosity + 0.8))) * 33.468 + 23.097;
		let targetViscMod = (Math.log10(Math.log10(targetViscosity + 0.8))) * 33.468 + 23.097;
		let fuel2Part = MathFormula.roundAccurately((targetViscMod - fuel1ViscMod) / (fuel2ViscMod - fuel1ViscMod), 4);
		let viscRatio = new Ratio(1 - fuel2Part, fuel2Part);
		return viscRatio;

	}


	// <summary>Calculates the blend ratio based on a given target blend flash point</summary>
	// <param name="comp1FlashPoint">Flash point of 1st blend component</param>
	// <param name="comp2FlashPoint">Flash point of 2nd blend component</param>
	// <param name="targetFlashPoint">Target flash point of final blend</param>
	// <returns>A ratio object containing the calculated ratio</returns>
	// <remarks></remarks>
	GetFlashPointRatio(comp1FlashPoint, comp2FlashPoint, targetFlashPoint) {
		
		let fuel1FPIndex = Math.pow(10, (-6.1188 + (2414.0 / (comp1FlashPoint + 230.6))));
		let fuel2FPIndex = Math.pow(10,(-6.1188 + (2414.0 / (comp2FlashPoint + 230.6))));
		let targetFPIndex = Math.pow(10,(-6.1188 + (2414.0 / (targetFlashPoint + 230.6))));

		//- dblFPIndex_Blend = (dblFPIndex_2nd * X)+(dblFPIndex_1st * (1-X))
		let fuel2Part = MathFormula.roundAccurately((fuel1FPIndex - targetFPIndex) / (fuel1FPIndex - fuel2FPIndex), 4);
		let flashPointRatio = new Ratio(1 - fuel2Part, fuel2Part);
		return flashPointRatio;
	}

	// <summary>Calculates the blend ratio for a proportional blending parameter</summary>
	// <param name="comp1Value">Property value of 1st blend component</param>
	// <param name="comp2Value">Property value of 2nd blend component</param>
	// <param name="targetValue">Target property value of final blend</param>
	// <returns>A ratio object containing the calculated ratio</returns>
	// <remarks></remarks>
	GetProportionalRatio(comp1Value, comp2Value, targetValue) {

		let fuel2Part = MathFormula.roundAccurately(Math.abs((targetValue - comp1Value) / (comp2Value - comp1Value)), 4);
		let proportionalRatio = new Ratio(1 - fuel2Part, fuel2Part);
		return proportionalRatio;
	}

	// <summary>This function checks whether a submitted property value is a numeric value.
	// It also checks whether the value is greater than zero. </summary>
	// <param name="value">Value to check</param>
	// <returns>true if numeric and > 0; otherwise false.</returns>
	VerifyValue(value) {
		let number = {};
		if (value.toString().trim().length == 0 || !MathFormula.TryParseFloat(value, number)) {
			return false;
		}

		if (number.value > 0 && !Approximates(number, 0)) {
			return true;
		}
		else {
			return false;
		}
	}

}